import type { ThreadMessage } from '@bcecloud/portal-ui';
import { route, type Route } from '../adapter';
import { newId, now } from '../store';
import type { NewMessage } from '@/lib/workspace';

/** The internal thread on the event. */

interface RichNode {
  readonly type?: string;
  readonly text?: string;
  readonly attrs?: { readonly id?: string; readonly label?: string };
  readonly content?: readonly RichNode[];
}

function textOf(node: RichNode): string {
  if (node.text) return node.text;
  if (node.type === 'mention') return `@${node.attrs?.label ?? ''}`;
  const inner = (node.content ?? []).map(textOf).join('');
  return node.type === 'paragraph' ? `${inner}\n` : inner;
}

function mentionsOf(node: RichNode): { membershipId: string; name: string }[] {
  if (node.type === 'mention') return [{ membershipId: node.attrs?.id ?? '', name: node.attrs?.label ?? '' }];
  return (node.content ?? []).flatMap(mentionsOf);
}

export const messageRoutes: readonly Route[] = [
  route('GET', '/events/:id/internal-messages', ({ store }) => ({ data: store.messages })),
  route('GET', '/events/:id/internal-messages/candidates', ({ store }) => ({ data: store.candidates })),
  route('POST', '/events/:id/internal-messages', ({ store, body }) => {
    const write = body as NewMessage;
    const content = write.content as unknown as RichNode;
    const message: ThreadMessage = {
      id: newId(),
      body: textOf(content).trim(),
      content: write.content,
      authorName: 'You',
      authorKind: 'BCE',
      mentions: mentionsOf(content),
      createdAt: now(),
      mine: true,
      kind: 'NOTE',
      parentId: write.parentId ?? null,
    };
    store.messages = [...store.messages, message];
    return { data: message };
  }),
];
